import {EnterpriseService} from '@digital-advice/ms-enterprise-sdk';
import {apiKey, getLogger, interceptors, resolveEndpointForServiceToken, sourceInfo} from '@advisor/services/sdk';

interface EnterpriseServiceOptions {
  hasServiceTokenEndpoint?: boolean;
}

export const defaultOptions: EnterpriseServiceOptions = {
  hasServiceTokenEndpoint: false,
};

export default class EnterpriseServices {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static async sdkService(options: EnterpriseServiceOptions = defaultOptions) {
    const service = await new EnterpriseService({
      logger: getLogger(),
      apiKey,
      endpoint: resolveEndpointForServiceToken(options.hasServiceTokenEndpoint),
      interceptors,
      sourceInfo,
    });

    return service;
  }

  /**
   * Gateway endpoint: getEnterpriseFeaturessetSdkOptions
   * @param {Number} enterpriseId
   */
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static async getEnterpriseFeatures(enterpriseId) {
    const serviceOptions: EnterpriseServiceOptions = {
      hasServiceTokenEndpoint: true,
    };
    const sdkService = await this.sdkService(serviceOptions);

    return sdkService.getEnterpriseFeatures(enterpriseId);
  }
}
